'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetStruct = exports.updateStruct = exports.stopStructFetch = exports.startStructFetch = exports.getStruct = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.reducer = reducer;

var _utils = require('./utils');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var validateStructId = function validateStructId(structId) {
  if (process.env.NODE_ENV !== 'production' && !(0, _utils.getIsValidStructId)(structId)) {
    // eslint-disable-next-line no-console
    console.warn('Expected nonempty string or integer as struct id, got ' + structId);
  }
};

var defaultStructState = {
  isFetching: false,
  error: null,
  data: null
};

var start = function start(state, _ref) {
  var structId = _ref.structId;

  validateStructId(structId);
  return _extends({}, state, {
    isFetching: true,
    error: null
  });
};

var stop = function stop(state, _ref2) {
  var structId = _ref2.structId,
      payload = _ref2.payload;

  validateStructId(structId);
  var hasError = payload instanceof Error;
  return _extends({}, state, {
    isFetching: false,
    error: hasError ? payload : defaultStructState.error,
    data: hasError ? state.data : payload || defaultStructState.data
  });
};

var update = function update(state, _ref3) {
  var structId = _ref3.structId,
      payload = _ref3.payload;

  validateStructId(structId);
  return _extends({}, state, payload);
};

function struct() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStructState;
  var action = arguments[1];

  switch (action.type) {
    case 'struct/START_FETCH':
      return start(state, action);
    case 'struct/STOP_FETCH':
      return stop(state, action);
    case 'struct/UPDATE':
      return update(state, action);
    case 'struct/RESET':
      return defaultStructState;
    default:
      return state;
  }
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case 'struct/START_FETCH':
    case 'struct/STOP_FETCH':
    case 'struct/UPDATE':
    case 'struct/RESET':
      {
        var structId = action.structId;

        return _extends({}, state, _defineProperty({}, structId, struct(state[structId], action)));
      }
    default:
      return state;
  }
}

var getStructState = function getStructState(state) {
  return state.struct;
};

var getStruct = exports.getStruct = function getStruct(structId) {
  var getState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getStructState;
  return function (state) {
    validateStructId(structId);
    return getState(state)[structId] || defaultStructState;
  };
};

var startStructFetch = exports.startStructFetch = function startStructFetch(structId) {
  return { type: 'struct/START_FETCH', structId: structId };
};
var stopStructFetch = exports.stopStructFetch = function stopStructFetch(structId, payload) {
  return { type: 'struct/STOP_FETCH', structId: structId, payload: payload };
};
var updateStruct = exports.updateStruct = function updateStruct(structId, payload) {
  return { type: 'struct/UPDATE', structId: structId, payload: payload };
};
var resetStruct = exports.resetStruct = function resetStruct(structId) {
  return { type: 'struct/RESET', structId: structId };
};